/**
 * AiChatSessionMetadata — Compact footer showing duration and turns after response completes.
 */

import { Clock, RotateCcw } from 'lucide-react';
import type { AiChatRunMetadata } from '../types';

type AiChatSessionMetadataProps = {
  metadata: AiChatRunMetadata;
};

function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSec = Math.round(seconds % 60);
  return `${minutes}m ${remainingSec}s`;
}

export function AiChatSessionMetadata({ metadata }: AiChatSessionMetadataProps) {
  return (
    <div
      className="flex items-center gap-3 px-8 py-1 text-[11px] text-muted-foreground"
      data-testid="ai-chat-session-metadata"
    >
      <span className="flex items-center gap-1">
        <Clock className="h-3 w-3" />
        {formatDuration(metadata.durationMs)}
      </span>
      <span className="flex items-center gap-1">
        <RotateCcw className="h-3 w-3" />
        {metadata.numTurns} {metadata.numTurns === 1 ? 'turn' : 'turns'}
      </span>
    </div>
  );
}
